import EventDTO from '../models/event';

// La venta pública del evento todavía no abrió: hasta `sales_start_at` la página
// del evento muestra "Próximamente" y no deja entrar a elegir entradas.
// Solo visual: la API no bloquea órdenes y el backoffice sigue vendiendo.
const isEventComingSoon = (event: Pick<EventDTO, 'sales_start_at'> | null | undefined, now: Date = new Date()) => {
  if (!event?.sales_start_at) {
    return false;
  }
  return new Date(event.sales_start_at).getTime() > now.getTime();
};

export default isEventComingSoon;
